export function wrapObject(obj) {

  let wrappedObj = {};
  Object.keys(obj).forEach((key) => {
    var o = { value: '', isDirty: obj[key] ? obj[key].isDirty : false, isValid: true };

    if (obj[key] === "N")
      o.value = false;
    else if (obj[key] === "Y")
      o.value = true;
    else
      o.value = obj[key] != null ? obj[key] : null;

    wrappedObj[key] = o;

  });
  return wrappedObj;
}

export function unwrapObject(obj) {

  let unwrappedObj = {};
  Object.keys(obj).forEach(key => {
    if (obj[key].value === true)
      unwrappedObj[key] = "Y";
    else if (obj[key].value === false)
      unwrappedObj[key] = "N";
    else
      unwrappedObj[key] = obj[key].value;
  })

  return unwrappedObj;
}
